import RawCard from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { SingleLineText, Checkbox, Button as RawButton } from '@bloomays-lib/ui.shared';
import RawCardActions from '@mui/material/CardActions';
import Typography from '@mui/material/Typography';
import { CRAStatus } from '@bloomays-lib/types.shared';
import { styled } from '@mui/material/styles';
import { useState } from 'react';
import { convertDateToStringFormat } from '@bloomays-lib/utils.shared';
import { useTranslation } from 'react-i18next';

export type ActionForceCRAProps = {
  activityId: string;
  craStatus: CRAStatus;
  missionLabel: string;
  activityMonth?: Date;
  clickHandler: (force: boolean) => Promise<void>;
};

const ActionForceCRA = ({ activityId, craStatus, clickHandler, missionLabel, activityMonth }: ActionForceCRAProps) => {
  const [force, setForce] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const { t } = useTranslation(['invoiceAction']);
  return (
    <Card>
      <CardContent>
        <StyledTypo>{missionLabel}</StyledTypo>
        <ContainerData>
          <ContainerTextLabel>
            <CenteredSingleLineText text={`${t('stateLabel')} `} span={craStatus} />
          </ContainerTextLabel>
          <ContainerTextLabel>
            <CenteredSingleLineText text={`${t('activityIdLabel')} `} span={activityId} />
          </ContainerTextLabel>
          {activityMonth ? (
            <ContainerTextLabel>
              <CenteredSingleLineText
                text={`${t('monthLabel')} `}
                span={convertDateToStringFormat(activityMonth, 'MM/yyyy')}
              />
            </ContainerTextLabel>
          ) : null}
        </ContainerData>
      </CardContent>
      <CardActions>
        <Checkbox
          label={t('forceValidateLabel')}
          id={'force'}
          name={'force'}
          checked={force}
          onChange={async (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
            setTimeout(() => {
              setLoading(true);
            }, 10);
            await setForce(checked);
            setTimeout(() => {
              setLoading(false);
            }, 10);
          }}
        />
        <Button
          id="handleInvoice"
          onClick={() => clickHandler(force)}
          textButton={t('validateLabel')}
          loading={loading}
          disabled={loading}
        />
      </CardActions>
    </Card>
  ) as React.ReactNode;
};

export default ActionForceCRA;
export { ActionForceCRA };

const Card = styled(RawCard)(() => ({
  width: '100%',
  margin: '1.5em 0',
  paddingBottom: 10,
  paddingTop: 10,
  boxShadow: '2px 2px 20px lightgrey !important',
  borderRadius: '10px !important',
}));

const StyledTypo = styled(Typography)(() => ({
  padding: '0px 0px 16px 16px',
  fontWeight: 'bold',
}));

const ContainerData = styled('div')(() => ({
  paddingLeft: 16,
}));

const CenteredSingleLineText = styled(SingleLineText)(() => ({}));

const CardActions = styled(RawCardActions)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
}));

const ContainerTextLabel = styled('div')(() => ({
  display: 'flex',
}));

const Button = styled(RawButton)(({ theme }) => ({
  border: 'none',
  padding: '0.7em 1.4em',
  marginRight: 10,
  borderRadius: '8px',
  backgroundColor: theme.palette.red[60],
  color: theme.palette.neutral.white,
  boxShadow: '2px 2px 5px rgb(201, 201, 201)',
  paddingRight: '16px',
  '&:hover': {
    cursor: 'pointer',
    backgroundColor: theme.palette.neutral.white,
    color: theme.palette.blue[60],
    transition: '0.52s ease',
  },
}));
